<template>
  <span class="connector-brand-icon" :class="`brand-${normalizedBrand}`" :style="iconStyle" aria-hidden="true">
    <svg v-if="normalizedBrand === 'chatgpt'" viewBox="0 0 48 48" role="img">
      <path d="M24 8.3a9.5 9.5 0 0 1 16.1 7.2 9.5 9.5 0 0 1-.5 15.7 9.5 9.5 0 0 1-13 11.4 9.5 9.5 0 0 1-15.7-4.3A9.5 9.5 0 0 1 7.8 23a9.5 9.5 0 0 1 11.8-13.1A9.4 9.4 0 0 1 24 8.3Z" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linejoin="round"/>
      <path d="m15.5 18 8.5-5 8.5 5v10L24 33l-8.5-5V18Zm0 0 8.5 5 8.5-5M24 23v10" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg v-else-if="normalizedBrand === 'claude'" viewBox="0 0 48 48" role="img">
      <g fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round">
        <path d="M24 7v10M24 31v10M7 24h10M31 24h10M12 12l7 7M29 29l7 7M36 12l-7 7M19 29l-7 7"/>
        <path d="m16 24 8-4 8 4-8 4-8-4Z" stroke-linejoin="round"/>
      </g>
    </svg>
    <svg v-else-if="normalizedBrand === 'gstocky'" viewBox="0 0 48 48" role="img">
      <path d="M35.2 17.2A13.7 13.7 0 1 0 37 29.8V24H25.5" fill="none" stroke="currentColor" stroke-width="5.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg v-else viewBox="0 0 48 48" role="img">
      <path d="M10 12h28v20H21l-8 6v-6h-3V12Z" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linejoin="round"/>
      <path d="M17 20h14M17 25h10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'ConnectorBrandIcon',
  props: {
    brand: { type: String, default: 'generic' },
    size: { type: [Number, String], default: 44 }
  },
  computed: {
    normalizedBrand () {
      const value = String(this.brand || '').toLowerCase()
      return ['chatgpt', 'claude', 'gstocky'].includes(value) ? value : 'generic'
    },
    iconStyle () {
      const value = typeof this.size === 'number' ? `${this.size}px` : this.size
      return { width: value, height: value }
    }
  }
}
</script>

<style scoped>
.connector-brand-icon {
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 13px;
  color: #fff;
  box-shadow: 0 5px 14px rgba(15, 23, 42, .14);
}
.connector-brand-icon svg { width: 72%; height: 72%; }
.brand-chatgpt { background: #111827; }
.brand-claude { background: #d97745; }
.brand-gstocky { background: #0b56b3; }
.brand-generic { background: #64748b; }
</style>
